import Alpine from "alpinejs";

// In your Alpine store initialization
const onboarding = {
  showWelcome: !localStorage.getItem("onboarding_completed"),

  completeOnboarding() {
    localStorage.setItem("onboarding_completed", "true");
    localStorage.removeItem("sw_stop_nagging"); // fresh start
    this.showWelcome = false;
    if(Alpine.store('location').latitude || Alpine.store('location').longitude) {
      return;
    }
    Alpine.store('location').queryCoordinates();
  },

  resetOnboarding() {
    localStorage.removeItem("onboarding_completed");
    this.showWelcome = true;
  },
};

export default onboarding;
